import api from "./api";

const libraryService = {
    // ── Books ──────────────────────────────────────────────────────────────
    // GET /api/library/books?search=&category=&page=&limit=
    getBooks: (params = {}) => api.get("/library/books", { params }),
    // GET /api/library/books/:id
    getBookById: (id) => api.get(`/library/books/${id}`),
    // POST /api/library/books
    createBook: (data) => api.post("/library/books", data),
    // PUT /api/library/books/:id
    updateBook: (id, data) => api.put(`/library/books/${id}`, data),
    // DELETE /api/library/books/:id
    removeBook: (id) => api.delete(`/library/books/${id}`),

    // ── Issue / Return ────────────────────────────────────────────────────
    // GET /api/library/issues?status=&search=&page=&limit=
    getIssues: (params = {}) => api.get("/library/issues", { params }),
    // GET /api/library/issues/overdue
    getOverdueIssues: () => api.get("/library/issues/overdue"),
    // GET /api/library/issues/student/:studentId
    getIssuesByStudent: (studentId) => api.get(`/library/issues/student/${studentId}`),
    // POST /api/library/issues
    issueBook: (data) => api.post("/library/issues", data),
    // PUT /api/library/issues/:id/return
    returnBook: (issueId) => api.put(`/library/issues/${issueId}/return`),

    // ── Fine Payments ─────────────────────────────────────────────────────
    // PUT /api/library/issues/:id/submit-payment
    submitFinePayment: (issueId, proofDataUrl) =>
        api.put(`/library/issues/${issueId}/submit-payment`, { proofDataUrl }),
    // PUT /api/library/issues/:id/verify-payment
    verifyFinePayment: (issueId, action, remarks) =>
        api.put(`/library/issues/${issueId}/verify-payment`, { action, remarks }),

    // ── Settings ──────────────────────────────────────────────────────────
    // GET /api/library/settings
    getSettings: () => api.get("/library/settings"),
    // PUT /api/library/settings
    updateSettings: (data) => api.put("/library/settings", data),
    // PUT /api/library/settings/qr
    uploadQRCode: (qrCodeDataUrl) => api.put("/library/settings/qr", { qrCodeDataUrl }),
};

export default libraryService;